import { cloneDeep } from 'lodash';
import WorkdayApi from 'client/api/v2/WorkdayApi';
import createModel from 'client/store/modules/models/createModel';

export const getDefaultItem = () => ({
  auth: null,
  id: '',
  lastImportDate: null,
  name: 'Workday Import',
  reportUrl: '',
});

const model = createModel(getDefaultItem, 'id', WorkdayApi);

export default {
  namespaced: true,

  state: {
    ...model.state,
  },

  actions: {
    ...model.actions,

    /**
     * Authorize workday and if successful then fetch a fresh copy of the the Workday instance so
     * that the new basic auth is present. When authorizing an existing Workday instance nothing is
     * returned so a fresh copy of the Workday instance must be retrieved to get the updated auth
     * info.
     */
    async authorizeWorkday({ dispatch, state }, { username, password }) {
      const { id, name } = state.item;
      await WorkdayApi.authorizeWorkday(id, name, username, password);
      await dispatch('fetchItem');
    },

    async deauthorizeWorkday({ commit, state }) {
      const { id } = state.item;
      await WorkdayApi.deauthorizeWorkday(id);
      commit('SET_ITEM', { auth: null });
      commit('SET_PREVIOUS_ITEM', { auth: null });
    },

    async fetchItem({ commit }) {
      try {
        const workdayId = await WorkdayApi.getWorkdayId();
        const item = await WorkdayApi.get(workdayId);
        commit('SET_ITEM', cloneDeep(item));
        commit('SET_PREVIOUS_ITEM', cloneDeep(item));
        commit('SET_ITEM_STATE', { update: true });
      } catch (exp) {
        // NOOP: A workday directory instance has not yet been created.
      }
    },
  },

  getters: {
    ...model.getters,

    displayName() {
      return 'Workday Import';
    },

    isAuthorized(state) {
      const { auth } = state.item;

      if (auth) {
        const { basic, oauth } = auth;

        if (oauth) {
          return oauth.isValid;
        }

        if (basic) {
          return basic.isValid;
        }
      }

      return false;
    },
  },

  mutations: {
    ...model.mutations,
  },
};
